import type { SchemaOf } from '../../helpers';
import { Joi, makeAllRequired } from '../../helpers';

export interface IConfig {
  welcomeMessage: string;
  guidanceMessage?: string; // multiline strings added by using \n in the text
  logoUrl: string;
  welcomeButtonText?: string;
  thinkingVideoUrl: string;
  multipleLogoUrls?: string[];
  sleepPrimaryMessage: string;
  sleepSecondaryMessage: string;

  // view v2 related
  backgroundImageUrl?: string;
  backgroundColor: string;
  hasClock: boolean;
  clockTextColor: string;
  hasDeliveryCarousel: boolean;

  primaryLightColor: string; // welcome button left gradient
  primaryDarkColor: string; // welcome button right gradient, aimee eye center,

  secondaryColor: string; // aimee orb second ring

  primaryTextColor: string; // main view text
  secondaryTextColor: string; // color for clock and helper text

  welcomeButtonTextColor: string;

  hasBrandingText: boolean; // text in corner "by aimeeblue.com"
  brandingTextColor: string;

  bellColor: string;

  hideLogos: boolean;
  customCssUrl?: string;
}

export const schemaMap: SchemaOf<IConfig> = {
  welcomeMessage: Joi.string(),
  guidanceMessage: Joi.string(),
  logoUrl: Joi.string(),
  welcomeButtonText: Joi.string(),
  thinkingVideoUrl: Joi.string(),
  multipleLogoUrls: Joi.array().items(Joi.string()),
  sleepPrimaryMessage: Joi.string(),
  sleepSecondaryMessage: Joi.string(),

  // view v2 related
  backgroundImageUrl: Joi.string(),
  backgroundColor: Joi.string(),
  hasClock: Joi.boolean(),
  clockTextColor: Joi.string(),
  hasDeliveryCarousel: Joi.boolean(),
  primaryLightColor: Joi.string(),
  primaryDarkColor: Joi.string(),
  secondaryColor: Joi.string(),
  primaryTextColor: Joi.string(),
  secondaryTextColor: Joi.string(),
  welcomeButtonTextColor: Joi.string(),
  hasBrandingText: Joi.boolean(),
  brandingTextColor: Joi.string(),
  bellColor: Joi.string(),

  hideLogos: Joi.boolean(),
  customCssUrl: Joi.string(),
};

export const schemaMapDefault = makeAllRequired<IConfig>(schemaMap, [
  'guidanceMessage',
  'welcomeButtonText',
  'multipleLogoUrls',
  'backgroundImageUrl',
  'customCssUrl',
]);

export const defaultConfig: IConfig = {
  welcomeMessage: 'Welcome',
  logoUrl: 'https://storage.googleapis.com/ab-media-aus/aimeeblue-logo.svg',
  thinkingVideoUrl:
    'https://storage.googleapis.com/ab-media-aus/animation-repeat.mp4',
  sleepPrimaryMessage: 'I am currently sleeping.',
  sleepSecondaryMessage: 'To wake me up just tap on the screen.',
  // view v2 related
  backgroundColor: '#010001',
  hasClock: false,
  clockTextColor: '#c1c1c1',
  hasDeliveryCarousel: false,
  primaryLightColor: '#fefefe',
  primaryDarkColor: '#fefefe',
  secondaryColor: '#fefefe',
  primaryTextColor: '#fefefe',
  secondaryTextColor: '#c1c1c1',
  welcomeButtonTextColor: '#010001',
  hasBrandingText: false,
  brandingTextColor: '#fefefe',
  bellColor: '#c1c1c1',
  hideLogos: false,
};
